import React from 'react';
import { useSelector } from 'react-redux';

import { RouteComponentProps } from 'react-router';
import { FormattedMessageV2 } from '@/views/components/i18n';
import { ALLOWED_HTML_TAGS } from '@/views/components/i18n/FormattedMessageV2';
import { TaxRegionKey } from '@capintel/instruments-lib';
import type { UsTaxImplicationsResult, CaTaxImplicationsResult } from '@capintel/instruments-lib';

import { CaTaxImplicationsTable, UsTaxImplicationsTable } from './components';

import ComparisonItem from '@/types/comparison-item';
import Comparison from '@/types/comparison';
import { ReduxState } from '@/redux/modules/types';

type TaxAnalysisTableProps = RouteComponentProps & {
  items: ComparisonItem[];
  comparison: Comparison;
  isEditPinned: boolean;
  popoverContainerRef?: HTMLElement | null;
};

function renderImplicationsTable(taxRegion: TaxRegionKey, taxImplications: UsTaxImplicationsResult | CaTaxImplicationsResult) {
  switch (taxRegion) {
    case TaxRegionKey.US:
      return <UsTaxImplicationsTable taxImplications={taxImplications as UsTaxImplicationsResult} />;
    case TaxRegionKey.CA:
      return <CaTaxImplicationsTable taxImplications={taxImplications as CaTaxImplicationsResult} />;
    default:
      return null;
  }
}

const TaxAnalysisTable: React.FC<TaxAnalysisTableProps> = () => {
  const activeComparison = useSelector((state: ReduxState) => state.comparison.activeComparison);
  const originalComparisonItemId = activeComparison?.taxAnalysis?.originalComparisonItemId;
  const taxRegion = activeComparison?.taxAnalysis?.taxSettings?.region;

  if (!taxRegion) {
    return null;
  }

  const comparisonItem = activeComparison?.items.find(item => item._id === originalComparisonItemId);
  const taxImplicationsData = comparisonItem?.taxAnalysis?.taxMetrics?.taxImplications;

  // Extract region-specific tax implications
  const taxImplications = taxImplicationsData?.[taxRegion];

  if (!taxImplications) {
    return null;
  }

  return (
    <div className="tax-transition-implications-table-container">
      <div className="transition-implications-table-card">
        <div className="tax-analysis-table-card-header">
          <FormattedMessageV2 tagName={ALLOWED_HTML_TAGS.H3} toLocalize="Comparison.TaxAnalysis.ImplicationsTable.Title" />
        </div>

        <div className="tax-analysis-table-scroll-wrapper">{renderImplicationsTable(taxRegion, taxImplications)}</div>
      </div>
    </div>
  );
};

export default TaxAnalysisTable;
